// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinkButton_wrapper__3wzcW","primary":"LinkButton_primary__XE-6U","danger":"LinkButton_danger___7qKb"};